import React, { useEffect, useState } from "react";
import "./AddDeal.css";
import AddLogVisiter from "./AddLogVisiter/AddLogVisiter";
import AddTransactionFile from "./AddTransactionFile/AddTransactionFile";
import AddTransactions from "./AddTransactions/AddTransactions";
import Agents from "./Agents/Agents";
import Clients from "./Clients/Clients";
import DealStatus from "./DealStatus/DealStatus";
import Interest from "./Interest/Interest";
import Properties from "./Properties/Properties";
import uniqid from "uniqid";
import { getAuth, updateCurrentUser } from "firebase/auth";
import { getEmailFromFirestore } from "../../controllers/notifications/get_tokens";
import addNotification from "../../controllers/notifications/store_notification";
import { doc, getDoc, query, setDoc, Timestamp } from "firebase/firestore";
import { db } from "../../firebase";
import getJsUTC from "../../helpers/getJsUTC";
import HelperForMetaData from "../../helpers/HelperForMetaData";
import SaveDealController from "./contoller/SaveDealController/SaveDealController";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";

import {
  AuthErrorMessages,
  ToastSuccessMessages,
} from "../../controllers/auth/AuthErrorMessages";
import { ToastContainer } from "react-toastify";
import GetSingleDeal from "../../controllers/Enquiries/GetSingleDeal";
import UpdateDealController from "./contoller/UpdateDealController/UpdateDealController";
import HeroLoader from "../../components/HeroLoader/HeroLoader";
import AddDealAppointments from "./AddDealAppointments/AddDealAppointments";
import GetDealAppointments from "../../controllers/appointments/GetDealAppointments";

const AddDeal = () => {
  //Error States
  //Client Error State
  const [clientError, setClientError] = useState(false);

  //Property Error State
  const [propertyError, setPropertyError] = useState(false);

  //Interest Error State
  const [interestError, setInterestError] = useState(false);

  //Agent Error State
  const [isAgentError, setAgentError] = useState(false);

  //data states

  //Client State
  const [client, setClient] = useState(null);

  //Client State
  const [isBtnDisable, setBtnDisable] = useState(true);

  //Property State
  const [property, setProperty] = useState(null);

  //Interest State
  const [interest, setInterest] = useState("");
  const [updateVarCount, setUpdateVarCount] = useState(0);

  const [comments, setComments] = useState([]);

  //Enqueries State
  const [agent, setAgent] = useState({});
  const [dealPrice, setDealPrice] = useState();

  //Status state
  const [dealStatus, setDealStatus] = useState("open");

  //Transaction state
  const [transactions, setTransactions] = useState([]);

  //Files state
  const [files, setFiles] = useState([]);

  //Log Visitors state
  const [appointments, setAppointments] = useState([]);
  //Client State
  const [appointmentClient, setAppointmentClient] = useState(null);

  //Log Visitors state
  const [visits, setVisits] = useState([]);

  //Log Visitors state
  const [dealId, setDealId] = useState("");
  const [dealData, setDealData] = useState();

  //Deal update state
  const [isUpdate, setIsUpdate] = useState(false);
  //  navigate

  const navigate = useNavigate();

  //location
  let location = useLocation();
  //function to create DealId for add Deal
  let DealId;
  useEffect(() => {
    const locationArr = location.pathname.split("/");

    // If it is update Deal get single deal data

    if (locationArr[3] == "update") {
      setIsUpdate(true);
      DealId = locationArr[4];
      setDealId(DealId);
      const fetchData = async () => {
        let deal = await GetSingleDeal(DealId);
        setAgent(deal.agent);

        setProperty(deal.property);
        setClient(deal.client);
        setDealStatus(deal.currentstatus);
        setDealPrice(deal.dealPrice);
        setInterest(deal.interest);
        setFiles(deal.files);
        setComments(deal.comments);
        setTransactions(deal.transactions);
        setVisits(deal.visits);
        setBtnDisable(false);

        const appointmentsArray = await GetDealAppointments(DealId);
        setAppointmentClient(appointmentsArray.clientObject);
        setAppointments(appointmentsArray);
      };
      fetchData();
    } else {
      DealId = uniqid() + uniqid() + uniqid();
      setDealId(DealId);
      setBtnDisable(false);
    }
  }, []);

  useEffect(() => {
    if (property !== null) {
      setDealPrice(property.sellingPrice);
    }
  }, [property]);
  useEffect(() => {
    setUpdateVarCount(updateVarCount + 1);

    if (property != null && client != null && agent != null) {
      let tempDealData = {
        client: client,
        property: property,
        dealPrice: dealPrice,
        interest: interest,
        agent: agent,
        currentstatus: dealStatus,
        comments: comments,
        files: files,
      };
      setDealData(tempDealData);
    }
  }, [
    client,
    property,
    dealPrice,
    interest,
    agent,
    dealStatus,
    comments,
    files,
  ]);
  useEffect(async () => {
    console.log("updateVarCount, ", updateVarCount);
    if (isUpdate && updateVarCount > 9) {
      const finalDealObject = HelperForMetaData({ ...dealData });
      await UpdateDealController(
        dealId,
        finalDealObject,
        transactions,
        visits,
        "dealData"
      );
      await dealStatusChange();
    }
  }, [dealData]);

  //ui states

  //derived states

  //functions

  const addOrUpdateTransactions = async () => {
    const finalDealObject = HelperForMetaData({ ...dealData });

    await UpdateDealController(
      dealId,
      finalDealObject,
      transactions,
      visits,
      "transactionData"
    );
  };
  const addOrUpdateVisits = async () => {
    const finalDealObject = HelperForMetaData({ ...dealData });

    await UpdateDealController(
      dealId,
      finalDealObject,
      transactions,
      visits,
      "visitData"
    );
  };
  /*  Sending Notification for open Deal   */
  const sendOpenDealNotification = async () => {
    let uid = getAuth().currentUser.uid;
    let userData = await getEmailFromFirestore(uid);

    const data = property;
    const title =
      userData.name + " Open the Deal for your " + data.propertySubType + "!";
    const description =
      userData.name + " Open the Deal for your " + data.propertySubType + "!";
    const notification_type = "Deal is Open";
    const notification_link =
      "https://app.landbook.pk" +
      "/user/properties/inventory/details/" +
      data.id;
    const record_id = dealId;
    const receiver_id = data.id;
    const is_seen = false;
    const is_deleted = false;
    const image = "";

    try {
      await addNotification(
        title,
        description,
        notification_type,
        image,
        notification_link,
        record_id,
        receiver_id,
        is_seen,
        is_deleted
      );
    } catch (ex) {}
  };

  /*  Deal Status change   */
  const dealStatusChange = async () => {
    if (dealStatus === "won") {
      let uid = getAuth().currentUser.uid;
      let userData = await getEmailFromFirestore(uid);
      const data = property;
      const title =
        userData.name + " Won the Deal for your " + data.propertySubType + "!";
      const description =
        userData.name + " Won the Deal for your " + data.propertySubType + "!";
      const notification_type = "Deal is Won";
      const notification_link =
        "https://app.landbook.pk" +
        "/user/properties/inventory/details/" +
        data.id;
      const record_id = dealId;
      const receiver_id = data.id;
      const is_seen = false;
      const is_deleted = false;
      const image = "";

      try {
        await addNotification(
          title,
          description,
          notification_type,
          image,
          notification_link,
          record_id,
          receiver_id,
          is_seen,
          is_deleted
        );
      } catch (ex) {}

      try {
        const propRef = query(doc(db, "properties", property.id));
        const propertySnap = await getDoc(propRef);
        await setDoc(doc(db, "properties", property.id), {
          ...propertySnap.data(),
          propertyStatus: propertySnap.rentalPrice === 0 ? "Rent Out" : "Sold",
          wonAt: Timestamp.fromDate(new Date(getJsUTC())),
        });
      } catch (ex) {
        console.log(ex);
      }
    } else {
      try {
        const propRef = query(doc(db, "properties", property.id));
        const propertySnap = await getDoc(propRef);
        await setDoc(doc(db, "properties", property.id), {
          ...propertySnap.data(),
          propertyStatus: "available",
        });
      } catch (ex) {
        console.log(ex);
      }
    }
  };
  const handleErrors = () => {};

  const handleSubmit = async () => {
    let flag = 0;
    setBtnDisable(true);
    if (client === null) {
      setClientError(true);
      flag++;
    } else {
      setClientError(false);
    }
    if (property === null) {
      flag++;
      setPropertyError(true);
    } else {
      setPropertyError(false);
    }

    if (interest === "") {
      flag++;
      setInterestError(true);
    } else {
      setInterestError(false);
    }

    if (Object.keys(agent).length === 0) {
      setAgentError(true);
      flag++;
    } else {
      setAgentError(false);
    }
    if (flag === 0) {
      const finalDealObject = HelperForMetaData({ ...dealData });
      let resp;
      if (isUpdate) {
        resp = await UpdateDealController(
          dealId,
          finalDealObject,
          transactions,
          visits
        );
        await dealStatusChange();
      } else {
        resp = await SaveDealController(
          dealId,
          finalDealObject,
          transactions,
          visits
        );
        await sendOpenDealNotification();
      }

      if (resp) {
        ToastSuccessMessages("deal/creation-successful");

        setTimeout(() => {
          navigate("/user/deals");
        }, 2000);
      } else {
        AuthErrorMessages("deal/creation-error");
        setBtnDisable(false);
      }
    } else {
      AuthErrorMessages("deal/creation-error");
      setBtnDisable(false);
    }
  };

  const ErrorHandling = () => {
    let flag = 0;
    if (client === null) {
      setClientError(true);
      flag++;
    } else {
      setClientError(false);
    }
    if (property === null) {
      flag++;
      setPropertyError(true);
    } else {
      setPropertyError(false);
    }

    if (interest === "") {
      flag++;
      setInterestError(true);
    } else {
      setInterestError(false);
    }

    if (Object.keys(agent).length === 0) {
      setAgentError(true);
      flag++;
    } else {
      setAgentError(false);
    }
    return flag;
  };

  const [ToggleComponents, setToggleComponents] = useState(false);

  const Toggler = () => {
    setToggleComponents(!ToggleComponents);
  };

  return (
    <div className="global-body-container">
      <ToastContainer />
      <div className="add-deal-container">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className="deal-header">
            <div>
              <button
                onClick={() => navigate(-1)}
                className="custom-back-btn"
                type="button"
              >
                <ArrowBackIosRoundedIcon className="custom-back-btn-icon" />
                <span>Back</span>
              </button>
            </div>

            <h2 className="custom-heading add-deal-title">
              {isUpdate === false ? "create new deals" : "update deal"}
            </h2>
            {isUpdate === true ? (
              <div></div>
            ) : (
              <button
                type="submit"
                disabled={isBtnDisable}
                className={`${isBtnDisable ? "custom-disable-card" : ""} `}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.445 2.94141H2.555C2.14299 2.94272 1.74824 3.10698 1.45691 3.39831C1.16557 3.68965 1.00132 4.0844 1 4.49641V10.1764C1 10.9014 1.52 11.2114 2.155 10.8564L4.12 9.76141C4.33 9.64641 4.67 9.64641 4.875 9.76141L6.84 10.8564C7.475 11.2114 7.995 10.9014 7.995 10.1764V4.49641C7.99533 4.29253 7.9555 4.09058 7.87778 3.9021C7.80006 3.71362 7.68598 3.54229 7.54205 3.39789C7.39812 3.25349 7.22716 3.13886 7.03893 3.06054C6.85069 2.98222 6.64888 2.94173 6.445 2.94141Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 4.49641V10.1764C8 10.9014 7.48 11.2064 6.845 10.8564L4.88 9.76141C4.67 9.64641 4.33 9.64641 4.12 9.76141L2.155 10.8564C1.52 11.2064 1 10.9014 1 10.1764V4.49641C1 3.64141 1.7 2.94141 2.555 2.94141H6.445C7.3 2.94141 8 3.64141 8 4.49641Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11 2.555V8.235C11 8.96 10.48 9.265 9.845 8.915L8 7.885V4.495C8 3.64 7.3 2.94 6.445 2.94H4V2.555C4 1.7 4.7 1 5.555 1H9.445C10.3 1 11 1.7 11 2.555Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Save</span>
              </button>
            )}
          </div>

          <div className="add-deal-top-container">
            <DealStatus
              dealStatus={dealStatus}
              setDealStatus={setDealStatus}
              isUpdate={isUpdate}
              isBtnDisable={isBtnDisable}
            />
            <div className="add-deal-top">
              <div className="left">
                <Clients
                  client={client}
                  setClient={setClient}
                  isError={clientError}
                  isBtnDisable={isBtnDisable}
                  isUpdate={isUpdate}
                  dealStatus={dealStatus}
                />
                <Properties
                  property={property}
                  setProperty={setProperty}
                  interest={interest}
                  isError={propertyError}
                  isBtnDisable={isBtnDisable}
                />
                <Interest
                  interest={interest}
                  setInterest={setInterest}
                  comments={comments}
                  setComments={setComments}
                  isBtnDisable={isBtnDisable}
                  isError={interestError}
                />
              </div>
              <div className="right">
                <Agents
                  agent={agent}
                  setAgent={setAgent}
                  dealPrice={dealPrice}
                  setDealPrice={setDealPrice}
                  isAgentError={isAgentError}
                  isUpdate={isUpdate}
                  isBtnDisable={isBtnDisable}
                />
              </div>
            </div>
          </div>
          <div className="add-deal-bottom">
            <AddTransactions
              transactions={transactions}
              setTransactions={setTransactions}
              isBtnDisable={isBtnDisable}
              dealId={dealId}
              addOrUpdateTransactions={addOrUpdateTransactions}
              Toggler={Toggler}
              ToggleComponents={ToggleComponents}
            />
            <AddTransactionFile
              files={files}
              setFiles={setFiles}
              DealId={dealId}
              isUpdate={isUpdate}
              isBtnDisable={isBtnDisable}
              Toggler={Toggler}
              ToggleComponents={ToggleComponents}
            />

            {appointments.length !== 0 && (
              <AddDealAppointments
                appointments={appointments}
                setAppointments={setAppointments}
                selectedAppointmentClient={appointmentClient}
                isUpdate={isUpdate}
                isBtnDisable={isBtnDisable}
                dealId={dealId}
                ErrorHandling={ErrorHandling}
                dealData={dealData}
                Toggler={Toggler}
                ToggleComponents={ToggleComponents}
              />
            )}
            <AddLogVisiter
              visits={visits}
              setVisits={setVisits}
              selectedClient={client}
              isUpdate={isUpdate}
              isBtnDisable={isBtnDisable}
              dealId={dealId}
              addOrUpdateVisits={addOrUpdateVisits}
              Toggler={Toggler}
              ToggleComponents={ToggleComponents}
            />
          </div>
        </form>
      </div>
      {/* Loader */}
      {isBtnDisable && (
        <div className="interstitial-loader">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddDeal;
